'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var React = require('react');
var utils = require('@chakra-ui/utils');
var hooks = require('@chakra-ui/hooks');
require('../../icons/AccountAdd.js');
require('../../icons/AccountCheck.js');
require('../../icons/AccountRemove.js');
require('../../icons/AccountStar.js');
require('../../icons/Account.js');
require('../../icons/ArrowCollapse.js');
require('../../icons/ArrowDownDrop.js');
require('../../icons/ArrowExpand.js');
require('../../icons/ArrowLeftDrop.js');
require('../../icons/ArrowLeft.js');
require('../../icons/ArrowRightDrop.js');
require('../../icons/Bell.js');
require('../../icons/BullhornOutline.js');
require('../../icons/BurgerMenu.js');
require('../../icons/CalendarDetailed.js');
require('../../icons/CalendarOutline.js');
require('../../icons/CashOff.js');
require('../../icons/Cash.js');
require('../../icons/CautionDecagram.js');
require('../../icons/CautionOutline.js');
require('../../icons/CheckCircled.js');
require('../../icons/CheckDecagram.js');
require('../../icons/CheckOutlinedCircled.js');
require('../../icons/Check.js');
require('../../icons/ChevronDown.js');
require('../../icons/ChevronLeft.js');
require('../../icons/ChevronRight.js');
require('../../icons/ChevronUp.js');
require('../../icons/CircleOutline.js');
require('../../icons/ClipboardTextOutline.js');
require('../../icons/Clock.js');
require('../../icons/CloseCircleFilled.js');
require('../../icons/Close.js');
require('../../icons/CompareArrows.js');
require('../../icons/Corner.js');
require('../../icons/Critical.js');
require('../../icons/Delete.js');
require('../../icons/DocumentEditCircled.js');
require('../../icons/DocumentEditOutline.js');
require('../../icons/DotsVertical.js');
require('../../icons/DownloadFilled.js');
require('../../icons/Draft.js');
require('../../icons/Encryption.js');
require('../../icons/EuroOff.js');
require('../../icons/Euro.js');
require('../../icons/EyeOff.js');
require('../../icons/Eye.js');
require('../../icons/FlagCheckered.js');
require('../../icons/FwSet0Constructionyear1.js');
require('../../icons/FwSet0Constructionyear2.js');
require('../../icons/FwSet0Constructionyear3.js');
require('../../icons/FwSet0Constructionyear4.js');
require('../../icons/FwSet0Corner.js');
require('../../icons/FwSet0Corneretc.js');
require('../../icons/FwSet0CultivableLimited.js');
require('../../icons/FwSet0CultivableNo.js');
require('../../icons/FwSet0CultivableUnsure.js');
require('../../icons/FwSet0Cultivable.js');
require('../../icons/FwSet0ElevatorNo.js');
require('../../icons/FwSet0Elevator.js');
require('../../icons/FwSet0Flat.js');
require('../../icons/FwSet0Garage.js');
require('../../icons/FwSet0House.js');
require('../../icons/FwSet0IndustryDontKnow.js');
require('../../icons/FwSet0IndustryIndustry.js');
require('../../icons/FwSet0IndustryLiveBusiness.js');
require('../../icons/FwSet0IndustryOffice.js');
require('../../icons/FwSet0Industry.js');
require('../../icons/FwSet0KitchenNew.js');
require('../../icons/FwSet0KitchenNo.js');
require('../../icons/FwSet0KitchenOld.js');
require('../../icons/FwSet0LandDevelopmentFull.js');
require('../../icons/FwSet0LandDevelopmentInPart.js');
require('../../icons/FwSet0LandDevelopmentNo.js');
require('../../icons/FwSet0Level1.js');
require('../../icons/FwSet0Level2.js');
require('../../icons/FwSet0Level3.js');
require('../../icons/FwSet0Levelplus.js');
require('../../icons/FwSet0LivingspaceUnknown.js');
require('../../icons/FwSet0Livingspace100.js');
require('../../icons/FwSet0Livingspace200.js');
require('../../icons/FwSet0Livingspace200Plus.js');
require('../../icons/FwSet0ParkingNo.js');
require('../../icons/FwSet0Parking.js');
require('../../icons/FwSet0PlotUnknown.js');
require('../../icons/FwSet0Plot.js');
require('../../icons/FwSet0Plot1000.js');
require('../../icons/FwSet0Plot1000Plus.js');
require('../../icons/FwSet0Plot300.js');
require('../../icons/FwSet0Rooms.js');
require('../../icons/FwSet0SemiDetached.js');
require('../../icons/FwSet0TownhouseCorner.js');
require('../../icons/FwSet0TownhouseMiddle.js');
require('../../icons/GiftCircled.js');
require('../../icons/Hausgold.js');
require('../../icons/HelpOutline.js');
require('../../icons/Help.js');
require('../../icons/HomeOutline.js');
require('../../icons/HouseCircled.js');
require('../../icons/HousePerson.js');
require('../../icons/House.js');
require('../../icons/Industry.js');
require('../../icons/InfoFilled.js');
require('../../icons/InfoOutline.js');
require('../../icons/LabelPercent.js');
require('../../icons/Level2.js');
require('../../icons/LightbulbOn.js');
require('../../icons/LockCircledOutline.js');
require('../../icons/Lock.js');
require('../../icons/Magnifier.js');
require('../../icons/Mail.js');
require('../../icons/Map.js');
require('../../icons/MissingOutline.js');
require('../../icons/OkCircled.js');
require('../../icons/OpenBookOutline.js');
require('../../icons/PageFirst.js');
require('../../icons/PageLast.js');
require('../../icons/Pause.js');
require('../../icons/Pen.js');
require('../../icons/Percent.js');
require('../../icons/PhoneCircled.js');
require('../../icons/Phone.js');
require('../../icons/PiggyBankCircled.js');
require('../../icons/PiggyBank.js');
var Plus = require('../../icons/Plus.js');
require('../../icons/PremiumStars.js');
require('../../icons/Printer.js');
require('../../icons/RealtyCommercial.js');
require('../../icons/RealtyFlat.js');
require('../../icons/RealtyHouse.js');
require('../../icons/RealtySite.js');
require('../../icons/Rocket.js');
require('../../icons/Rooms.js');
require('../../icons/SpeechBubble.js');
require('../../icons/SpeechBubbles.js');
require('../../icons/Speedometer.js');
require('../../icons/Star.js');
require('../../icons/StatusDontknow.js');
require('../../icons/SwapHorizontalBold.js');
require('../../icons/ThumbDownOutline.js');
require('../../icons/ThumbUpOutline.js');
require('../../icons/TruckFastOutline.js');
require('../../icons/UnorderedList.js');
require('../../icons/User.js');
var reactUtils = require('@chakra-ui/react-utils');
var useInputFileUtils = require('./useInputFileUtils.js');
var utils$1 = require('./utils.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["inputProps", "multiple", "onChange", "defaultValue", "value", "normalizeCustomType", "isCustomType"],
  _excluded2 = ["value"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function useInputFile(props) {
  var inputProps = props.inputProps,
    multiple = props.multiple,
    onChangeProp = props.onChange,
    defaultValueProp = props.defaultValue,
    valueProp = props.value,
    _props$normalizeCusto = props.normalizeCustomType,
    normalizeCustomTypeProp = _props$normalizeCusto === void 0 ? utils$1.normalizeCustomType : _props$normalizeCusto,
    _props$isCustomType = props.isCustomType,
    isCustomTypeProp = _props$isCustomType === void 0 ? utils$1.isCustomType : _props$isCustomType,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  if (!!normalizeCustomTypeProp && !isCustomTypeProp || !isCustomTypeProp && !!normalizeCustomTypeProp) {
    throw new Error('You must provide both `normalizeCustomType` and `isCustomType` if you want to use a custom file type.');
  }
  var utils$2 = React.useMemo(function () {
    return new useInputFileUtils.UseInputFileUtils(normalizeCustomTypeProp, isCustomTypeProp);
  }, [normalizeCustomTypeProp, isCustomTypeProp]);
  var ref = React__default["default"].useRef(null);
  var _useControllableState = hooks.useControllableState({
      value: valueProp,
      defaultValue: defaultValueProp,
      onChange: utils.callAll(function (_value) {
        try {
          ref.current.files = utils$2.toFileList(_value);
        } catch (_unused) {
          /*
           * This catch is only here for Jest.
           *
           * JSDOM accurately mocks the HTMLInputElement with a setter for
           * `files` but even though that is the case, an error is thrown that
           * `files` only has a getter.
           * J
           * JSDOM source code proves it wrong; and it even is inside that code
           * when debugging. So why?!
           */
        }
      }, onChangeProp)
    }),
    _useControllableState2 = _slicedToArray__default["default"](_useControllableState, 2),
    value = _useControllableState2[0],
    setValue = _useControllableState2[1];

  /*
   * Using form control context is required to properly grab form control
   * handled states like `isDisabled`, `isInvalid` and pass them on as
   * necessary.
   * It also allows us to grab the generated `id` and aria labels which are
   * otherwise only applied to the components next to this component
   * (`FormControl`, `FormError`, `Label`), but not `InputFile` itself.
   */
  var formControl = react.useFormControl(rest);
  var _ref2 = formControl || {},
    isDisabled = _ref2.disabled,
    isInvalid = _ref2['aria-invalid'],
    isReadOnly = _ref2.readOnly;

  /** Prop handling */
  var _split = utils.split(rest, react.layoutPropNames),
    _split2 = _slicedToArray__default["default"](_split, 2),
    layoutProps = _split2[0],
    otherProps = _split2[1];

  /** Is `true` if the input is full. */
  var isFull = !multiple && (value === null || value === void 0 ? void 0 : value.length) === 1;

  /** Visibility state of the upload button */
  var isVisible = !isFull;

  /**
   * Handles file changes.
   */
  var handleOnChange = React.useCallback(function (event) {
    var _event$target, _event$target2;
    var files = event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.files ? Array.from(event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.files) : [];
    setValue(utils$2.add(files, value));
  }, [setValue, utils$2, value]);

  /**
   * Stops event execution if user clears the input.
   * Clearing should only happen if user clicks the clear button.
   */
  var handleClearing = React.useCallback(function (event) {
    var _event$target3;
    if ((event === null || event === void 0 ? void 0 : (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.value) === '') {
      event.preventDefault();
    }
  }, []);
  var getHtmlProps = React.useCallback(function () {
    var givenProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread(_objectSpread({}, layoutProps), givenProps);
  }, [layoutProps]);
  var getInputProps = React.useCallback(function () {
    var givenProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, otherProps), inputProps), formControl), givenProps), {}, {
      multiple: multiple,
      type: 'file',
      ref: reactUtils.mergeRefs(ref, _ref),
      onChange: utils.callAllHandlers(handleClearing, handleOnChange)
    });
  }, [otherProps, inputProps, formControl, multiple, handleClearing, handleOnChange]);
  var getButtonProps = React.useCallback(function () {
    var givenProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread({
      as: 'span',
      size: 'sm',
      variant: 'link',
      leftIcon: /*#__PURE__*/React__default["default"].createElement(Plus.Plus, null),
      colorScheme: isInvalid ? 'red' : 'blue',
      display: !isVisible ? 'none' : undefined,
      opacity: isDisabled ? 0.4 : undefined,
      isDisabled: isDisabled,
      ref: _ref
    }, givenProps);
  }, [isDisabled, isInvalid, isVisible]);
  var _onDelete = React.useCallback(function (_file) {
    if (value && _file) {
      setValue(utils$2.remove(_file, value));
    }
  }, [value, setValue, utils$2]);
  var getFileProps = React.useCallback(function (_ref3) {
    var givenValue = _ref3.value,
      givenProps = _objectWithoutProperties__default["default"](_ref3, _excluded2);
    return _objectSpread(_objectSpread({}, givenProps), {}, {
      value: utils$2.computeAssetLike(givenValue),
      isDisabled: isDisabled || isReadOnly,
      key: utils$2.computeKey(givenValue),
      onDelete: function onDelete(event) {
        event.stopPropagation();
        _onDelete(givenValue);
      }
    });
  }, [isDisabled, isReadOnly, _onDelete, utils$2]);
  return {
    getHtmlProps: getHtmlProps,
    getInputProps: getInputProps,
    getFileProps: getFileProps,
    getButtonProps: getButtonProps,
    value: value,
    setValue: setValue,
    onDelete: _onDelete,
    isDisabled: isDisabled,
    isInvalid: isInvalid,
    isReadOnly: isReadOnly
  };
}
exports.useInputFile = useInputFile;